import vu_CV from 'assets/portfolio/cv/vu_CV.pdf'
import nam_CV from 'assets/portfolio/cv/nam_CV.pdf'
import tuan_CV from 'assets/portfolio/cv/tuan_CV.pdf'

const downloadFile = (url, fileName) => {
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.target = '_blank'
  anchor.download = fileName

  anchor.click()

  anchor.remove()
}

export const downloadCVs = () => {
  const cvFiles = [
    { url: vu_CV, name: 'vu_CV.pdf' },
    { url: nam_CV, name: 'nam_CV.pdf' },
    { url: tuan_CV, name: 'tuan_CV.pdf' }
  ]

  cvFiles.forEach(({ url, name }) => {
    downloadFile(url, name)
  })
}
